export const defaultStrokeWidth = 2

export const baseFontSize = 15
